import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Utils/CommonComponents/CommonCardHeader";
import CommonFileUpload from "../../../../Utils/CommonComponents/CommonFileUpload";
import { MultiFileUploadTitle } from "../../../../Utils/Constants";

export default function MultiFileUpload() {
  return (
    <Col lg={6}>
      <Card>
        <CommonCardHeader title={MultiFileUploadTitle} />
        <CardBody>
          <CommonFileUpload multiple />
        </CardBody>
      </Card>
    </Col>
  );
}
